export enum EnumTipoObjeto {
  Instituicao = 0,
  Banca = 1,
  Ano = 2,
  Tipo = 3,
  Cargo = 4,
  Guias = 5,
  Marcacoes = 6,
  Comentarios = 7,
  Grifos = 8,
  Estatisticas = 9,
  Apontamentos = 10,
  Preferencias = 11,
  Referencias = 12,
}
